import React from 'react';
import { ExportCSVButton } from "../../ExportCSVButton";
import '../graphStyles.scss'
import { GraphDropDown } from '../GraphDropDown'
import { Row, Col } from 'react-bootstrap'
import NoDataFound from "../../NoDataFound"
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Filler,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    Filler,
    BarController
  )




export function VisitorEngagementAndAddToCartGraph({ display, weeks, percentVisitors, percentBooking, percentBuying, nameLabels}) {

    const [currentWeek, setCurrentWeek] = React.useState(0)

    const options = {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
            display: display === 'dashboard' ? false : true,
            labels: {
                font: {
                    size: function() {
                      if (display !== 'dashboard' && window.innerWidth < 830) {
                        return 9
                      }
                      else if (window.innerWidth < 830 & window.innerWidth > 570) {
                        return 9
                      } else {
                        return 13
                      }
                    },
                },
                filter: (l) => (l.text !== 'none')
            },
            onHover: function (event, legendItem) {
              document.getElementById("chart2").style.cursor = 'pointer';
            },
            onLeave: function (event, legendItem) {
              document.getElementById("chart2").style.cursor = 'default';
            },
          },
        },

        scales: {
            x: {
                title: {
                    text: "Number of Sessions",
                    display: display === 'dashboard' ? false : true,
                    font: {
                        size: function() {
                          if (display !== 'dashboard' && window.innerWidth < 830) {
                            return 10
                          }
                          else if (window.innerWidth < 830 & window.innerWidth > 570) {
                            return 10
                          } else {
                            return 13
                          }
                        },
                        
                      },
                },
                grid: {
                    display: false
                },
                ticks: {
                    font: {
                        size: function() {
                          if (display !== 'dashboard' && window.innerWidth < 830) {
                            return 9
                          }
                          else if (window.innerWidth < 750 & window.innerWidth > 570) {
                            return 9
                          } else {
                            return 13
                          }
                        },
                        
                      },
                }
            },
            y: {
                position: 'left',
                title: {
                    text: "% of Visitors",
                    display: display === 'dashboard' ? false : true,
                    font: {
                        size: function() {
                          if (display !== 'dashboard' && window.innerWidth < 830) {
                            return 10
                          }
                          else if (window.innerWidth < 750 & window.innerWidth > 570) {
                            return 10
                          } else {
                            return 13
                          }
                        },
                        
                    },
                },
                ticks: {
                    font: {
                        size: function() {
                          if (display !== 'dashboard' && window.innerWidth < 830) {
                            return 9
                          }
                          else if (window.innerWidth < 830 & window.innerWidth > 570) {
                            return 9
                          } else {
                            return 13
                          }
                        },
                      },
                }
            },

            y1: {
                position: 'right',
                title: {
                    text: "% of Visitors",
                    display: display === 'dashboard' ? false : true,
                    font: {
                        size: function() {
                          if (display !== 'dashboard' && window.innerWidth < 830) {
                            return 10
                          }
                          else if (window.innerWidth < 830 & window.innerWidth > 570) {
                            return 10
                          } else {
                            return 13
                          }
                        },
                    },
                },
                ticks: {
                    font: {
                        size: function() {
                          if (display !== 'dashboard' && window.innerWidth < 830) {
                            return 9
                          }
                          else if (window.innerWidth < 830 & window.innerWidth > 570) {
                            return 9
                          } else {
                            return 13
                          }
                        },
                    },
                }
            }
        }
    }


    const labels = nameLabels[currentWeek]

    const data = {
        labels,
        datasets: [
          {
            label: percentBuying[currentWeek] === undefined ? 'none' : (percentBuying[currentWeek].length !== 1 ? '% of Visitors Buying in this Cohort' : 'none'),

            data: percentBuying[currentWeek],
            type: 'line',
            fill: true,
            borderWidth: 3,
            yAxisID: 'y1',
            order: 2,
            pointRadius: 3,
            borderColor: percentBuying[currentWeek] === undefined ? 'rgba(0,0,0,0)' : (percentBuying[currentWeek].length !== 1 ? 'rgba(255, 216, 90, 1)' : 'rgba(0,0,0,0)'),
            backgroundColor: percentBuying[currentWeek] === undefined ? 'rgba(0,0,0,0)' : (percentBuying[currentWeek].length !== 1 ? 'rgba(255, 216, 90, 0.5)' : 'rgba(0,0,0,0)'),
            hoverBackgroundColor: percentBuying[currentWeek] === undefined ? 'rgba(0,0,0,0)' : (percentBuying[currentWeek].length !== 1 ? 'rgba(255, 216, 90, 0.5)' : 'rgba(0,0,0,0)'),
          },
          {
            label: '% of Visitors Booking in this Cohort',

            data: percentBooking[currentWeek],
            yAxisID: 'y1',
            borderColor: 'rgba(0, 50, 248, 0.83)',
            backgroundColor: 'rgba(0, 50, 248, 0.83)',
            hoverBackgroundColor: 'rgba(0, 50, 248, 0.83)',
            order: 0,
            type: 'line',
            pointRadius: 3,
          },
          {
            label: '% of Visitors',

            data: percentVisitors[currentWeek],
            backgroundColor: 'rgba(150, 167, 200, 0.99)',
            hoverBackgroundColor: 'rgba(150, 167, 200, 0.99)',
            yAxisID: 'y',
            order: 1,
          },
        ],
      }



      /**
       * Hard coded data values for the 4 graphs on dashboard page to always
       * display the 4 most recent weeks
       */
      const dataOne = {
        labels,
        datasets: [
          {
            data: percentBuying[0],
            type: 'line',
            fill: true,
            borderWidth: 3,
            yAxisID: 'y1',
            order: 2,
            pointRadius: 3,
            borderColor: percentBuying[0] === undefined ? 'rgba(0,0,0,0)' : (percentBuying[0].length !== 1 ? 'rgba(255, 216, 90, 1)' : 'rgba(0,0,0,0)'),
            backgroundColor: percentBuying[0] === undefined ? 'rgba(0,0,0,0)' : (percentBuying[0].length !== 1 ? 'rgba(255, 216, 90, 0.5)' : 'rgba(0,0,0,0)'),
          },
          {
            label: '% of Visitors Booking in this Cohort',

            data: percentBooking[0],
            yAxisID: 'y1',
            borderColor: 'rgba(0, 50, 248, 0.83)',
            backgroundColor: 'rgba(0, 50, 248, 0.83)',
            order: 0,
            type: 'line',
            pointRadius: 3,
          },
          {
            label: '% of Visitors',

            data: percentVisitors[0],
            backgroundColor: 'rgba(150, 167, 200, 0.99)',
            yAxisID: 'y',
            order: 1,
          },
        ],
      }

      const dataTwo = {
        labels,
        datasets: [
          {
            data: percentBuying[1],
            type: 'line',
            fill: true,
            borderWidth: 3,
            yAxisID: 'y1',
            order: 2,
            pointRadius: 3,
            borderColor: percentBuying[1] === undefined ? 'rgba(0,0,0,0)' : (percentBuying[1].length !== 1 ? 'rgba(255, 216, 90, 1)' : 'rgba(0,0,0,0)'),
            backgroundColor: percentBuying[1] === undefined ? 'rgba(0,0,0,0)' : (percentBuying[1].length !== 1 ? 'rgba(255, 216, 90, 0.5)' : 'rgba(0,0,0,0)'),
          },
          {
            label: '% of Visitors Booking in this Cohort',

            data: percentBooking[1],
            yAxisID: 'y1',
            borderColor: 'rgba(0, 50, 248, 0.83)',
            backgroundColor: 'rgba(0, 50, 248, 0.83)',
            order: 0,
            type: 'line',
            pointRadius: 3,
          },
          {
            label: '% of Visitors',

            data: percentVisitors[1],
            backgroundColor: 'rgba(150, 167, 200, 0.99)',
            yAxisID: 'y',
            order: 1,
          },
        ],
      }

      const dataThree = {
        labels,
        datasets: [
          {
            data: percentBuying[2],
            type: 'line',
            fill: true,
            borderWidth: 3,
            yAxisID: 'y1',
            order: 2,
            pointRadius: 3,
            borderColor: percentBuying[2] === undefined ? 'rgba(0,0,0,0)' : (percentBuying[2].length !== 1 ? 'rgba(255, 216, 90, 1)' : 'rgba(0,0,0,0)'),
            backgroundColor: percentBuying[2] === undefined ? 'rgba(0,0,0,0)' : (percentBuying[2].length !== 1 ? 'rgba(255, 216, 90, 0.5)' : 'rgba(0,0,0,0)'),
          },
          {
            label: '% of Visitors Booking in this Cohort',

            data: percentBooking[2],
            yAxisID: 'y1',
            borderColor: 'rgba(0, 50, 248, 0.83)',
            backgroundColor: 'rgba(0, 50, 248, 0.83)',
            order: 0,
            type: 'line',
            pointRadius: 3,
          },
          {
            label: '% of Visitors',

            data: percentVisitors[2],
            backgroundColor: 'rgba(150, 167, 200, 0.99)',
            yAxisID: 'y',
            order: 1,
          },
        ],
      }



      const dataFour = {
        labels,
        datasets: [
          {
            data: percentBuying[3],
            type: 'line',
            fill: true,
            borderWidth: 3,
            yAxisID: 'y1',
            order: 2,
            pointRadius: 3,
            borderColor: percentBuying[3] === undefined ? 'rgba(0,0,0,0)' : (percentBuying[3].length !== 1 ? 'rgba(255, 216, 90, 1)' : 'rgba(0,0,0,0)'),
            backgroundColor: percentBuying[3] === undefined ? 'rgba(0,0,0,0)' : (percentBuying[3].length !== 1 ? 'rgba(255, 216, 90, 0.5)' : 'rgba(0,0,0,0)'),
          },
          {
            label: '% of Visitors Booking in this Cohort',

            data: percentBooking[3],
            yAxisID: 'y1',
            borderColor: 'rgba(0, 50, 248, 0.83)',
            backgroundColor: 'rgba(0, 50, 248, 0.83)',
            order: 0,
            type: 'line',
            pointRadius: 3,
          },
          {
            label: '% of Visitors',

            data: percentVisitors[3],
            backgroundColor: 'rgba(150, 167, 200, 0.99)',
            yAxisID: 'y',
            order: 1,
          },
        ],
      }


      const allData = [
        ["Buying Percentage Data"],
        [`Week of ${weeks[0]}`, percentBuying[0]],
        [`Week of ${weeks[1]}`, percentBuying[1]],
        [`Week of ${weeks[2]}`, percentBuying[2]],
        [`Week of ${weeks[3]}`, percentBuying[3]],
        [],
        ["Booking Percentage Data"],
        [`Week of ${weeks[0]}`, percentBooking[0]],
        [`Week of ${weeks[1]}`, percentBooking[1]],
        [`Week of ${weeks[2]}`, percentBooking[2]],
        [`Week of ${weeks[3]}`, percentBooking[3]],
        [],
        ["Visitor Percentage Data"],
        [`Week of ${weeks[0]}`, percentVisitors[0]],
        [`Week of ${weeks[1]}`, percentVisitors[1]],
        [`Week of ${weeks[2]}`, percentVisitors[2]],
        [`Week of ${weeks[3]}`, percentVisitors[3]],
      ];

      return (
        <div className="graph">
          <div className="graph__title flex flex-col md:flex-row justify-between items-center">
            <h4 className="text-lg md:text-xl font-semibold text-center md:text-left mb-2 md:mb-0">
              Visitor engagement and added to cart
            </h4>
            <ExportCSVButton
              allData={allData}
              name={"Visitor Engagement & Add to Cart Data"}
              className="w-full md:w-auto"
            />
            <GraphDropDown
              display={display}
              currentWeek={currentWeek}
              setCurrentWeek={setCurrentWeek}
              weeks={weeks}
              className="w-full md:w-auto"
            />
          </div>
    
          {weeks.length === 0 ? (
            <NoDataFound />
          ) : (
            // Main dashboard display with 4 graphs in 2 by 2 grid
            <div>
              {display === "dashboard" ? (
                <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="small__chart__container">
                    <div className="engagement__date">Week of {weeks[0]}</div>
                    <Chart
                      className="small__chart"
                      id="chart2"
                      type="bar"
                      options={options}
                      data={dataOne}
                    />
                  </div>
    
                  <div className="small__chart__container">
                    <div className="engagement__date">Week of {weeks[1]}</div>
                    <Chart
                      className="small__chart"
                      id="chart2"
                      type="bar"
                      options={options}
                      data={dataTwo}
                    />
                  </div>
    
                  <div className="small__chart__container">
                    <div className="engagement__date">Week of {weeks[2]}</div>
                    <Chart
                      className="small__chart"
                      id="chart2"
                      type="bar"
                      options={options}
                      data={dataThree}
                    />
                  </div>
    
                  <div className="small__chart__container">
                    <div className="engagement__date">Week of {weeks[3]}</div>
                    <Chart
                      className="small__chart"
                      id="chart2"
                      type="bar"
                      options={options}
                      data={dataFour}
                    />
                  </div>
                </div>
              ) : (
                // Content performance page display
                <div className="content__engagement__container relative w-full h-64 md:h-96">
                  <Chart
                    className="chart content__engagement__chart"
                    id="chart2"
                    type="bar"
                    options={options}
                    data={data}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      );
    }